import { createIcon } from '@chakra-ui/icons'

const M3U8Icon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#A64F4F"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        M3U8
      </text>
      <path
        fill="#E1E4EB"
        d="M-5273.8 4798.2h-.4c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3h.4c.2 0 .3.1.3.3 0 .1-.2.3-.3.3z"
      />
      <path
        fill="#E1E4EB"
        d="M-5262.7 4798.2h-2c-.2 0-.3-.1-.3-.3s.1-.3.3-.3h2c3.4 0 6.2-2.8 6.2-6.2 0-2.6-1.6-4.9-4.1-5.8-.1 0-.2-.1-.2-.2-1.1-5-6.1-8.2-11.1-7.1-3.6.8-6.3 3.6-7.1 7.2 0 .2-.2.3-.4.3h-.1c-1.8-.7-3.8.2-4.5 1.9-.1.3-.2.6-.2.9 0 .1-.1.2-.2.3-2.4.7-3.8 3.2-3.1 5.6.6 1.9 2.3 3.3 4.4 3.3h6.8c.2 0 .3.1.3.3s-.1.3-.3.3h-6.8c-2.9 0-5.2-2.3-5.2-5.2 0-2.2 1.4-4.2 3.6-4.9.3-2 2.1-3.4 4.1-3.4.4 0 .8.1 1.2.2 1.3-5.3 6.8-8.6 12.1-7.2 3.6.9 6.4 3.7 7.3 7.4 3.5 1.4 5.2 5.5 3.8 9-1.2 2.2-3.7 3.9-6.5 3.9z"
      />
      <path
        fill="#E1E4EB"
        d="M-5264.7 4809.1h-14.7c-.2 0-.3-.1-.3-.3v-17.9c0-.2.1-.3.3-.3h14.7c.2 0 .3.1.3.3v17.9c0 .2-.1.3-.3.3zm-14.3-.7h14v-17.2h-14v17.2z"
      />
      <path
        fill="#E1E4EB"
        d="M-5274.2 4802.3c-.2 0-.3-.1-.3-.3v-4.3c0-.2.1-.3.3-.3h.2l4.3 2.2c.2.1.2.3.1.4 0 .1-.1.1-.1.1l-4.3 2.2h-.2zm.3-4.1v3.3l3.3-1.6-3.3-1.7z"
      />
      <path
        fill="#E1E4EB"
        d="M-5267.8 4809.1c-.2 0-.3-.1-.3-.3v-17.9c0-.2.1-.3.3-.3.2 0 .3.1.3.3v17.9c0 .2-.1.3-.3.3z"
      />
      <path
        fill="#E1E4EB"
        d="M-5276.3 4809.1c-.2 0-.3-.1-.3-.3v-17.9c0-.2.1-.3.3-.3.2 0 .3.1.3.3v17.9c.1.2-.1.3-.3.3z"
      />
      <path
        fill="#E1E4EB"
        d="M-5276.3 4794.3h-3.1c-.2 0-.3-.1-.3-.3s.1-.3.3-.3h3.1c.2 0 .3.1.3.3s-.1.3-.3.3z"
      />
      <path
        fill="#E1E4EB"
        d="M-5276.3 4802.1h-3.1c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3h3.1c.2 0 .3.1.3.3.1.2-.1.3-.3.3z"
      />
      <path
        fill="#E1E4EB"
        d="M-5276.3 4806h-3.1c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3h3.1c.2 0 .3.1.3.3.1.2-.1.3-.3.3z"
      />
      <path
        fill="#E1E4EB"
        d="M-5264.7 4794.3h-3.1c-.2 0-.3-.1-.3-.3s.1-.3.3-.3h3.1c.2 0 .3.1.3.3s-.1.3-.3.3z"
      />
      <path
        fill="#E1E4EB"
        d="M-5264.7 4798.2h-3.1c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3h3.1c.2 0 .3.1.3.3 0 .2-.1.3-.3.3z"
      />
      <path
        fill="#E1E4EB"
        d="M-5264.7 4802.1h-3.1c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3h3.1c.2 0 .3.1.3.3 0 .2-.1.3-.3.3z"
      />
      <path
        fill="#E1E4EB"
        d="M-5264.7 4806h-3.1c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3h3.1c.2 0 .3.1.3.3 0 .2-.1.3-.3.3z"
      />
    </g>
  ),
})

export default M3U8Icon
